var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dialogVisible
    ? _c(
        "div",
        { attrs: { id: "login_panel", name: "Login" } },
        [
          _c(
            "el-dialog",
            {
              attrs: {
                title: "",
                visible: _vm.dialogVisible,
                width: "488px",
                height: "672px",
                "close-on-click-modal": false,
                "before-close": _vm.handleClose,
                "z-index": 5000
              },
              on: {
                "update:visible": function($event) {
                  _vm.dialogVisible = $event
                }
              }
            },
            [
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.activeName,
                    callback: function($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName"
                  }
                },
                [
                  !_vm.isSmsLogin
                    ? _c(
                        "el-tab-pane",
                        { attrs: { label: _vm.$t("login"), name: "login" } },
                        [
                          _c(
                            "div",
                            { staticClass: "phone mB16 mT16" },
                            [
                              _c("el-input", {
                                staticClass: "phone_call ime_mode_dis",
                                attrs: {
                                  placeholder: _vm.$t("placeholders.phone"),
                                  type: "text"
                                },
                                nativeOn: {
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.doLogin.apply(null, arguments)
                                  }
                                },
                                model: {
                                  value: _vm.phone,
                                  callback: function($$v) {
                                    _vm.phone = $$v
                                  },
                                  expression: "phone"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("placeholders.psd"),
                              maxlength: 16,
                              minlength: 6,
                              type: "password"
                            },
                            nativeOn: {
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.doLogin.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.password,
                              callback: function($$v) {
                                _vm.password = $$v
                              },
                              expression: "password"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "forget_password" }, [
                            _c(
                              "span",
                              { on: { click: _vm.toForgetPassword } },
                              [_vm._v(_vm._s(_vm.$t("forget")))]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn_login mB32",
                              attrs: {
                                type: "primary",
                                disabled: !_vm.canLogin,
                                round: ""
                              },
                              on: { click: _vm.doLogin }
                            },
                            [_vm._v(_vm._s(_vm.$t("login")))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "line-text" }, [
                            _vm._v(_vm._s(_vm.$t("others")))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mT24 container" }, [
                            _c(
                              "div",
                              {
                                staticClass: "wx-container cursor",
                                on: { click: _vm.triggerSmsLogin }
                              },
                              [
                                _c("div", { staticClass: "img-icon" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/login/PC-短信登录.png"),
                                      alt: ""
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "mT8" }, [
                                  _vm._v(_vm._s(_vm.$t("smsLogin")))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "wx-container cursor",
                                on: { click: _vm.toWeChatLogin }
                              },
                              [
                                _c("div", { staticClass: "img-icon" }, [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../../assets/img/login/PC-微信登录.png"),
                                      alt: ""
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "mT8" }, [
                                  _vm._v(_vm._s(_vm.$t("weChatLogin")))
                                ])
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    : _c(
                        "el-tab-pane",
                        { attrs: { label: _vm.$t("smsLogin"), name: "login" } },
                        [
                          _c(
                            "div",
                            { staticClass: "phone mB16 mT16" },
                            [
                              _c("el-input", {
                                staticClass: "phone_call ime_mode_dis",
                                attrs: {
                                  placeholder: _vm.$t("placeholders.phoneOnly"),
                                  type: "tel",
                                  minlength: 11,
                                  maxlength: 11
                                },
                                nativeOn: {
                                  keyup: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.doLogin(true)
                                  }
                                },
                                model: {
                                  value: _vm.phone,
                                  callback: function($$v) {
                                    _vm.phone = $$v
                                  },
                                  expression: "phone"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("el-input", { staticStyle: { display: "none" } }),
                          _vm._v(" "),
                          _c(
                            "el-input",
                            {
                              attrs: {
                                placeholder: _vm.$t(
                                  "placeholders.smsValidateCode"
                                ),
                                maxlength: 6,
                                minlength: 6,
                                autocomplete: "new-password"
                              },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.doLogin(true)
                                }
                              },
                              model: {
                                value: _vm.smsValidateCode,
                                callback: function($$v) {
                                  _vm.smsValidateCode = $$v
                                },
                                expression: "smsValidateCode"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "append",
                                  class: {
                                    active: _vm.timeRemain == 60 && _vm.phone
                                  },
                                  attrs: { slot: "append" },
                                  slot: "append"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "cursor",
                                      on: { click: _vm.getSmsValidateCode }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.timeRemain == 60
                                            ? _vm.$t("sendSmsCode")
                                            : _vm.$t("resendSmsCode") +
                                                "(" +
                                                _vm.timeRemain +
                                                ")s"
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "forget_password tal" }, [
                            _c("span", { on: { click: _vm.triggerSmsLogin } }, [
                              _vm._v(_vm._s(_vm.$t("acountLogin")))
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "btn_login mB32",
                              attrs: {
                                type: "primary",
                                disabled: !_vm.smsLoginDisabled,
                                round: ""
                              },
                              on: {
                                click: function($event) {
                                  return _vm.doLogin(true)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("login")))]
                          )
                        ],
                        1
                      ),
                  _vm._v(" "),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: _vm.$t("register"), name: "register" } },
                    [
                      _c(
                        "div",
                        { staticClass: "phone mB16 mT16" },
                        [
                          _c("el-input", {
                            staticClass: "phone_call ime_mode_dis",
                            staticStyle: { "ime-mode": "disabled" },
                            attrs: {
                              placeholder: _vm.$t("placeholders.phone")
                            },
                            on: { blur: _vm.cheackLeago },
                            model: {
                              value: _vm.phone,
                              callback: function($$v) {
                                _vm.phone = $$v
                              },
                              expression: "phone"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "phone mB16" },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "verify_input",
                              attrs: {
                                maxlength: 4,
                                placeholder: _vm.$t("placeholders.graphCode")
                              },
                              model: {
                                value: _vm.inputGraphCode,
                                callback: function($$v) {
                                  _vm.inputGraphCode = $$v
                                },
                                expression: "inputGraphCode"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "append",
                                  attrs: { slot: "append" },
                                  slot: "append"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "verify_img_box",
                                      on: { click: _vm.getGraphCode }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.graphInfo.graphUrl,
                                          alt: ""
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "phone mB16" },
                        [
                          _c(
                            "el-input",
                            {
                              staticClass: "phone_call",
                              attrs: {
                                maxlength: 6,
                                placeholder: _vm.$t("placeholders.verifCode")
                              },
                              model: {
                                value: _vm.smscode,
                                callback: function($$v) {
                                  _vm.smscode = $$v
                                },
                                expression: "smscode"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "append",
                                  class: {
                                    active:
                                      _vm.timeInterval == 60 &&
                                      _vm.canGetVerifCode
                                  },
                                  attrs: { slot: "append" },
                                  slot: "append"
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "cursor",
                                      on: { click: _vm.getVerifCode }
                                    },
                                    [_vm._v(_vm._s(_vm.verifTip))]
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "phone mB16" },
                        [
                          _c("el-input", {
                            staticClass: "verify_input",
                            attrs: {
                              placeholder: _vm.$t("placeholders.psd"),
                              maxlength: 16,
                              minlength: 6,
                              type: "password"
                            },
                            model: {
                              value: _vm.regPassword,
                              callback: function($$v) {
                                _vm.regPassword = $$v
                              },
                              expression: "regPassword"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "phone mB32" },
                        [
                          _c("el-input", {
                            staticClass: "verify_input",
                            attrs: {
                              placeholder: _vm.$t("placeholders.rpsd"),
                              maxlength: 16,
                              minlength: 6,
                              type: "password"
                            },
                            model: {
                              value: _vm.regPassword1,
                              callback: function($$v) {
                                _vm.regPassword1 = $$v
                              },
                              expression: "regPassword1"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "protral_private" },
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.agreement,
                                callback: function($$v) {
                                  _vm.agreement = $$v
                                },
                                expression: "agreement"
                              }
                            },
                            [_c("b", [_vm._v(_vm._s(_vm.$t("readAndAgreed")))])]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.toPage("newprofile")
                                }
                              }
                            },
                            [_vm._v("《" + _vm._s(_vm.$t("profile")) + "》")]
                          ),
                          _vm._v("、"),
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.toPage("newprivateInfo")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "《" + _vm._s(_vm.$t("privateInfo")) + "》"
                              )
                            ]
                          ),
                          _vm._v("、"),
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.toPage("childrenProfile")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "《" + _vm._s(_vm.$t("childernProfile")) + "》"
                              )
                            ]
                          ),
                          _c("span", { staticStyle: { color: "#030A17" } }, [
                            _vm._v(_vm._s(_vm.$t("flowLogin70")))
                          ]),
                          _c(
                            "span",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.toPage("childrenPrivateInfo")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "《" +
                                  _vm._s(_vm.$t("childrenPrivateInfo")) +
                                  "》"
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "btn_login",
                          staticStyle: { "margin-bottom": "10px" },
                          attrs: {
                            type: "primary",
                            disabled: !_vm.canRegister,
                            round: ""
                          },
                          on: { click: _vm.doRegister }
                        },
                        [_vm._v(_vm._s(_vm.$t("register")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("span", {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer"
              })
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-abde1a6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-abde1a6e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/plugin/login-register/src/main.vue
// module id = null
// module chunks = 